import { useEffect, useRef, useState } from 'react';
import WebProductCategoryEdit from './WebProductCategoryEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { Space } from 'antd';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';

const WebProductCategory = (props: any) => {
    const ref = useRef<any>(undefined);
    /** 服务id */
    const apiId = 'webProductCategory';
    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();
    const [productNatureData, setProductNatureData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFetchData(() => ref.current.fetchData);
            setSendPageData(ref.current.sendPageData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'productNature',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { productNature } = res.data;
                    setProductNatureData([{ id: 'ALLITEM', name: '所有性质' }, ...productNature]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '大类',
            dataIndex: 'categoryName',
            sorter: true,
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
            sorter: true,
        },
    ];
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '产品大类',
        apiId,
        columns,
        editOptions: {
            Editor: WebProductCategoryEdit
        }
    };

    return (
        <> <Space>
            <CustomSelect
                apiId={apiId}
                sendKeyId='productNatureId'
                getListData={productNatureData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
            />
        </Space>
            <> </><WebUniversal {...extendProps} ref={ref} />
        </>)
}

export default WebProductCategory;
